
import { createSlice } from '@reduxjs/toolkit';

const userImageSlice = createSlice({
  name: 'userImage',
  initialState: '',
  reducers: {
    setUserImage(state, action) {
        return action.payload;
    },
  },
});
export const { setUserImage} = userImageSlice.actions;
export default userImageSlice.reducer;
